


class Carousel {
    defaultOptions() {
        return {
        	'$container': null,

            'animated': true,
            'slideshowSpeed': 5000,
            'animationSpeed': 500,


            'sliderSelector': '.home-header__big--items',
            'linkSelector': '.home-header__thumb--item',

        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.$container = this.settings.$container;

        if(!this.$container){
        	console.error("Missing $container in Carousel");
        }

        this.$slider = $(this.settings.sliderSelector,this.$container);

        this.initialize();
    }

	initialize(){
		var self = this;

        $(this.settings.linkSelector,this.$container).each(function(i) {
            let $item = $(this);
            $item.attr('data-pos',i);
            if(i == 0){
                $item.addClass('active');
            }
        });

       	this.$slider.flexslider({
            'animation': "fade",
            'controlNav': false,
            'directionNav':false,
            'animationLoop': this.settings.animated,
            'slideshow': this.settings.animated,
            'slideshowSpeed': this.settings.slideshowSpeed,
            'animationSpeed': this.settings.animationSpeed,
            'before': function(slider){
                let pos = slider.currentSlide;

                let $item = $(self.settings.linkSelector+'[data-pos="'+pos+'"]',self.$container);

                $item
                .removeClass('active');
            },
            'after': function(slider){

                let pos = slider.currentSlide;

                let $item = $(self.settings.linkSelector+'[data-pos="'+pos+'"]',self.$container);
                $item
                .addClass('active');
            },
            'start': function(slider) {
                $(self.settings.linkSelector,self.$container).click(function(event){
                    let $item = $(this);
                    var pos = $item.data('pos');

                    if (pos !== slider.currentSlide) {
                        slider.flexAnimate(pos, true);
                    }else{
                        let  $firstLink = $('a', '.flex-active-slide', self.$container).first();
                        if($firstLink.length > 0){
                            let href = $firstLink.attr('href');
                            if(href && href !== '#'){
                                window.location.href = href;
                            }
                        }

                    }
                });
            }
        });

	}

}

module.exports = Carousel ;
